module.exports = __webpack_public_path__ + "static/Banner-12-ff3c9efff55003d9588fe5a14c353f33.png";